import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

/**
 * A very light cross-page fade. No layout shift, no unmount animation —
 * pages stay instantly interactive, they just arrive gracefully.
 * Skipped entirely under prefers-reduced-motion.
 */
export default function RouteTransition({ children }: { children: React.ReactNode }) {
  const { pathname } = useLocation();
  const [key, setKey] = useState(pathname);

  useEffect(() => setKey(pathname), [pathname]);

  return (
    <div key={key} className="route-enter">
      {children}
    </div>
  );
}
